// Convert Blob to Base64 string
export const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
  
  // Save image to localStorage
  export const cacheProfileImage = (base64Image) => {
    localStorage.setItem("profileImage", base64Image);
  };
  
  // Load image from localStorage
  export const getCachedProfileImage = () => {
    return localStorage.getItem("profileImage");
  };
  
  // Clear image from localStorage
  export const clearCachedProfileImage = () => {
    localStorage.removeItem("profileImage");
  };
  